import { z } from 'zod';
import { requiredString } from '../helpers';
const hasValue = (value) => Boolean(value?.trim());
export const Snapsheet_List_Claims_1_ConfigValidator = z
    .object({
    connectionId: requiredString('Connection is required'),
    policyNumber: z.string().optional(),
    status: z.string().optional(),
    updatedSince: z.string().optional(),
    dateOfLossStart: z.string().optional(),
    dateOfLossEnd: z.string().optional()
})
    .refine((config) => hasValue(config.dateOfLossStart) === hasValue(config.dateOfLossEnd), {
    path: ['dateOfLossEnd'],
    message: 'Date of loss start and end must be provided together'
});
//# sourceMappingURL=snapsheet-list-claims-1.js.map